import { FaqItem } from 'pages/certificates/components/Faq/FaqItem'
import { TrackingAttributes } from 'pages/certificates/tracking'
import type { CohortContent } from '../types'

export const CohortFaq = ({ faq }: { faq: CohortContent['faq'] }) => (
  <TrackingAttributes location='FAQs'>
    <section className='my-11'>
      <h2 className='c-text-ivar-display-condensed c-heading-1 mb-9 text-center'>
        {faq.title}
      </h2>
      <div className='container'>
        {faq.items.map(({ question, answer }) => (
          <FaqItem key={question} question={question} theme='light'>
            {answer}
          </FaqItem>
        ))}
      </div>
    </section>
  </TrackingAttributes>
)
